import axios from "@/libs/api.request";

// 获取权限树结构
export const getPermissionTree = (roleid = 0) => {
  return axios.request({
    url: "/rbac/getPermissionTree",
    data: { roleid },
    csrf: false,
    method: "post"
  });
};
/**
 * 根据权限id获取权限以及角色
 * @param {权限id} id
 */
export const getPermissionById = id => {
  return axios.request({
    url: "/rbac/getPermissionById",
    data: { id },
    csrf: false,
    method: "post"
  });
};
export const storePermission = data => {
  return axios.request({
    url: "/rbac/storePermission",
    data: data,
    method: "post"
  });
};

/**
 * 获取所有权限对应的角色数组
 */

export const getPermissionRole = () => {
  axios.request({
    url: "/rbac/getPermissionRole",
    csrf: false,
    method: "post"
  });
};

export const isAllowPermission = (
  type,
  userid,
  departid,
  roles,
  folderdata
) => {
  // 1 如果是此目录是自己建立的，则此目录包含所有的权限
  //   console.log(folderdata);
  // if (userid === folderdata.userid) return true;
  let allowed = -1;
  let departlist = [];
  let userlist = [];
  let rolesperm = [];
  //   console.log(type);
  switch (type) {
    case "delete":
      departlist = JSON.parse(folderdata.departs_permission_delete);
      allowed = departlist.indexOf(departid);
      //   console.log('indepart', allowed);
      if (allowed === -1) {
        userlist = JSON.parse(folderdata.users_permission_delete);
        allowed = userlist.indexOf(userid);
        // console.log('inuser', userid, userlist, allowed);
      }
      if (allowed === -1) {
        rolesperm = JSON.parse(folderdata.roles_permission_delete);

        for (let i = 0; i < roles.length; i++) {
          if (rolesperm.indexOf(roles[i]) >= 0) {
            allowed = 0;
            break;
          }
        }
      }

      break;
    case "upload":
      departlist = JSON.parse(folderdata.departs_permission_write);

      allowed = departlist.indexOf(departid);
      //   console.log('indepart', departid, departlist, allowed);
      if (allowed === -1) {
        userlist = JSON.parse(folderdata.users_permission_write);
        allowed = userlist.indexOf(userid);
        // console.log('inuser', allowed);
      }
      if (allowed === -1) {
        rolesperm = JSON.parse(folderdata.roles_permission_write);

        for (let i = 0; i < roles.length; i++) {
          if (rolesperm.indexOf(roles[i]) >= 0) {
            allowed = 0;
            break;
          }
        }
      }

      break;
    case "download":
      departlist = JSON.parse(folderdata.departs_permission_download);
      allowed = departlist.indexOf(departid);
      //   console.log('indepart', allowed);
      if (allowed === -1) {
        userlist = JSON.parse(folderdata.users_permission_download);
        allowed = userlist.indexOf(userid);
        // console.log('inuser', allowed);
      }
      if (allowed === -1) {
        rolesperm = JSON.parse(folderdata.roles_permission_download);
        for (let i = 0; i < roles.length; i++) {
          if (rolesperm.indexOf(roles[i]) >= 0) {
            allowed = 0;
            break;
          }
        }
      }

      break;
  }
  if (allowed >= 0) {
    return true;
  } else {
    return false;
  }
};

/**
 * 判断是否用户具有流程的入口条件
 */

export const isAllowProcess = (
  userid,
  departid,
  roleidlist,
  useridset,
  departidset,
  roleidset
) => {
  let allowed = -1;
  allowed = useridset.indexOf(userid);
  if (allowed >= 0) {
    return true;
  } else {
    allowed = departidset.indexOf(departid);
    if (allowed >= 0) {
      return true;
    }
  }
  if (allowed === -1) {
    for (let i = 0; i < roleidlist.length; i++) {
      if (roleidset.indexOf(roleidlist[i]) >= 0) {
        allowed = 0;
        break;
      }
    }
    if (allowed >= 0) return true;
  }
  return false;
};

export const getKeyInfoPermission = keyColumn => {
  return axios.request({
    url: "/rbac/getKeyInfoPermission",
    data: { keyColumn },
    csrf: false,
    method: "post"
  });
};
export const storeKeyInfoPermission = data => {
  return axios.request({
    url: "/rbac/storeKeyInfoPermission",
    data: data,
    method: "post"
  });
};
